var map = {
	"./DST-logo.jpg": 30753,
	"./DST-logo.png": 74569,
	"./Search": 93823,
	"./Search.json": 93823,
	"./csir-logo.png": 39949,
	"./image.png": 8695,
	"./innovation-icon.png": 85789,
	"./math-icon.png": 53460,
	"./no-results.jpg": 2198,
	"./parnerships-active.png": 30242,
	"./parnerships-foreign.png": 98070,
	"./parnerships-local.png": 5111,
	"./parnerships-private.png": 8283,
	"./parnerships-public.png": 38047,
	"./pdf.png": 94742,
	"./robot-icon.png": 29048,
	"./saasta-logo.jpg": 89463,
	"./saasta-logo.png": 25703,
	"./saasta.png": 70063,
	"./science-icon.png": 73654,
	"./seims-login-background2.png": 68672,
	"./seims-logo.png": 58785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67516;